import React, { useEffect, useState, createContext, useContext } from "react";
import Form from "./pages/form"; // for form route
import Customizer from "./pages/customizer"; // for customizer route
import AllItems from "./pages/allItems";
import Footer from "./components/Footer/Footer";

import { HashRouter, Routes, Route } from "react-router-dom";
import jwt_decode from "jwt-decode";
import Navbar from "./components/Navbar/Navbar";
import Prehome from "./components/Pre-Home/Prehome";
import SentPage from "./components/SentPage/SentPage";
import NotFound from "./pages/notFound";
import Login from "./pages/login";
import Register from "./pages/register";
import Designs from "./pages/designs";
import GetEmail from "./pages/getEmail";
import logo from "../src/assests/Images/Logo.png";
import LogoUpload from "./pages/LogoUpload";



export const GlobalStateContext = createContext()

const App = () => {
  const [globalState, setGlobalState] = useState(null)
  const [token, setToken] = useState(localStorage.getItem("access_token"))

  useEffect(() => {
    if (token) {
      var { name, userId, role } = jwt_decode(token);
      console.log({ name, userId, role })
      if(role == "Admin") return
      const headers = { "Authorization": "Bearer " + localStorage.getItem("access_token") }

      fetch("https://friendly-jepsen.77-68-82-89.plesk.page/user/" + userId, { headers })
        .then(async res => {
          const userData = (await res.json()).data

          if(userData){
            const designAPI = await fetch("https://friendly-jepsen.77-68-82-89.plesk.page/design/" + userId, { headers })
            const galleryAPI = await fetch("https://friendly-jepsen.77-68-82-89.plesk.page/gallery/" + userId, { headers })
            
            const {design} = (await designAPI.json()).design
            const {gallery} = await galleryAPI.json()

            setGlobalState({
              userData,
              design,
              gallery
            })
          }
          else{
            localStorage.removeItem("access_token")
            setToken(null)
          }

        })
    }
  }, [token])

  useEffect(()=>{
    console.log("global state is changed: ", globalState)
  },[globalState])

  function Layout({ Inner }) {
    return (
      <>
      {
        window.screen.width>500 ?
        <>
        <Navbar token={token} setToken={setToken} />
        <Inner  setToken={setToken}/>
        <Footer />
      </>
      :
      <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-center">
        <h1 className="font-bold text-[20px] mb-2"><img src={logo} alt="logo" /></h1>
        <p>For best experience please use customiser on a desktop or laptop</p>
      </div>
    }
    </>
    )
  }

  return (
    <GlobalStateContext.Provider value={{globalState, setGlobalState}}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layout Inner={Prehome} />} />
          <Route path="/login" element={<Layout Inner={Login} />} />
          <Route path="/register" element={<Layout Inner={Register} />} />
          <Route path="/home" element={<Layout Inner={AllItems} />} />
          <Route path="/customizer" element={<Layout Inner={Customizer} />} />
          <Route path="/start" element={<Layout Inner={GetEmail} />} />
          <Route path="/form" element={<Layout Inner={Form} />} />
          <Route path="/sent-page" element={<Layout Inner={SentPage} />} />
          <Route path="/logo-upload" element={<Layout Inner={LogoUpload} />} />
          <Route path="/admin" element={<Designs tokenState={{token,setToken}} />} />
          <Route path="*" element={<Layout Inner={NotFound} />} />
        </Routes>
      </HashRouter>
    </GlobalStateContext.Provider>
  );
};

export default App;
